import { render, staticRenderFns } from "./TarefasDashboard.vue?vue&type=template&id=4e9c5e84"
import script from "./TarefasDashboard.vue?vue&type=script&lang=js"
export * from "./TarefasDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports